import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/products',
    name: 'products',
    component: () => import('../views/ProductsOverview.vue'),
    children: [      
      {
        path: 'ai-expert',
        name: 'AiExpert',
        component: () => import('../views/products/AiExpertView.vue')
      },
      {
        path: 'website-build',
        component: () => import('../views/products/WebsiteBuildView.vue')
      },
      {
        path: 'kol-helper',
        component: () => import('../views/products/KolHelperView.vue')
      }
    ]
  },
  {
    path: '/pricing',
    name: 'pricing',
    component: () => import('../views/PricingView.vue')
  },
  {
    path: '/faq',
    name: 'faq',
    component: () => import('../views/FaqView.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
